import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { formatXof } from '../utils/format';
import { confirmDialog } from '../utils/confirm';

const TSTATUS = { ACTIF: ['green', 'Actif'], ESSAI: ['gold', 'Essai'], SUSPENDU: ['red', 'Suspendu'], PROSPECT: ['navy', 'Prospect'] };
const BILLING = { MENSUEL: 'Mensuel', TRIMESTRIEL: 'Trimestriel', ANNUEL: 'Annuel' };

const FORMES_JURIDIQUES = [
  'SA', 'SARL', 'SAS', 'SASU', 'SNC', 'SCS', 'GIE',
  'Fondation', 'Association', 'Coopérative',
  'Établissement public', 'École privée laïque', 'École confessionnelle',
];

const GEO = {
  'Burkina Faso': {
    'Boucle du Mouhoun': ['Dédougou', 'Nouna', 'Tougan', 'Boromo', 'Solenzo'],
    'Cascades':          ['Banfora', 'Sindou', 'Mangodara'],
    'Centre':            ['Ouagadougou', 'Saaba', 'Koubri', 'Pabré'],
    'Centre-Est':        ['Tenkodogo', 'Koupéla', 'Pouytenga', 'Garango'],
    'Centre-Nord':       ['Kaya', 'Kongoussi', 'Boulsa'],
    'Centre-Ouest':      ['Koudougou', 'Léo', 'Réo', 'Sabou'],
    'Centre-Sud':        ['Manga', 'Kombissiri', 'Pô'],
    'Est':               ["Fada N'Gourma", 'Diapaga', 'Bogandé', 'Gayéri'],
    'Hauts-Bassins':     ['Bobo-Dioulasso', 'Houndé', 'Orodara'],
    'Nord':              ['Ouahigouya', 'Titao', 'Yako', 'Séguénéga'],
    'Plateau-Central':   ['Ziniaré', 'Zorgho', 'Boussé'],
    'Sahel':             ['Dori', 'Gorom-Gorom', 'Djibo'],
    'Sud-Ouest':         ['Gaoua', 'Diébougou', 'Batié', 'Kampti'],
  },
  'Sénégal': {
    'Dakar':         ['Dakar', 'Pikine', 'Guédiawaye', 'Rufisque', 'Bargny'],
    'Diourbel':      ['Diourbel', 'Touba', 'Bambey', 'Mbacké'],
    'Fatick':        ['Fatick', 'Foundiougne', 'Gossas'],
    'Kaffrine':      ['Kaffrine', 'Birkelane', 'Koungheul', 'Malem-Hoddar'],
    'Kaolack':       ['Kaolack', 'Nioro du Rip', 'Guinguinéo'],
    'Kédougou':      ['Kédougou', 'Saraya', 'Salémata'],
    'Kolda':         ['Kolda', 'Vélingara', 'Médina Yoro Fula'],
    'Louga':         ['Louga', 'Linguère', 'Kébémer'],
    'Matam':         ['Matam', 'Kanel', 'Ourossogui', 'Ranérou'],
    'Saint-Louis':   ['Saint-Louis', 'Richard-Toll', 'Podor', 'Dagana'],
    'Sédhiou':       ['Sédhiou', 'Bounkiling', 'Goudomp'],
    'Tambacounda':   ['Tambacounda', 'Bakel', 'Goudiry', 'Koumpentoum'],
    'Thiès':         ['Thiès', 'Mbour', 'Tivaouane', 'Joal-Fadiouth'],
    'Ziguinchor':    ['Ziguinchor', 'Bignona', 'Oussouye'],
  },
  'Bénin': {
    'Alibori':   ['Kandi', 'Banikoara', 'Malanville', 'Gogounou', 'Ségbana'],
    'Atacora':   ['Natitingou', 'Djougou', 'Tanguiéta', 'Boukoumbé', 'Cobly'],
    'Atlantique':['Abomey-Calavi', 'Ouidah', 'Allada', 'Zè', 'Tori-Bossito'],
    'Borgou':    ['Parakou', 'Tchaourou', "N'Dali", 'Pèrèrè', 'Bembèrèkè'],
    'Collines':  ['Savalou', 'Dassa-Zoumè', 'Bantè', 'Glazoué', 'Ouèssè'],
    'Couffo':    ['Aplahoué', 'Djakotomey', 'Klouékamè', 'Toviklin', 'Lalo'],
    'Donga':     ['Djougou', 'Bassila', 'Copargo', 'Ouaké'],
    'Littoral':  ['Cotonou'],
    'Mono':      ['Lokossa', 'Athiémé', 'Houéyogbé', 'Grand-Popo', 'Comè'],
    'Ouémé':     ['Porto-Novo', 'Adjarra', 'Avrankou', 'Bonou', 'Akpro-Missérété'],
    'Plateau':   ['Sakété', 'Pobè', 'Kétou', "Adja-Ouèrè", 'Ifangni'],
    'Zou':       ['Abomey', 'Bohicon', 'Zogbodomey', 'Agbangnizoun', 'Covè'],
  },
};

function Modal({ title, children, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal modal-wide" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ fontFamily: 'Space Grotesk, sans-serif', marginBottom: 16 }}>{title}</h2>
        {children}
      </div>
    </div>
  );
}

// ── Tableau de bord plateforme ──────────────────────────────
export function PlatformOverview() {
  const [o, setO] = useState(null);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  const navigate = useNavigate();
  function load() { api.get('/platform/overview').then(setO).catch((e) => setError(e.message)); }
  useEffect(load, []);
  async function del(id) {
    if (!(await confirmDialog({ title: 'Supprimer', message: 'Supprimer ce plan ?', confirmLabel: 'Supprimer', danger: true }))) return;
    try { await api.del(`/platform/plans/${id}`); load(); } catch (e) { setError(e.message); }
  }
  if (error) return <div className="panel"><div className="panel-body"><div className="form-error">{error}</div></div></div>;
  if (!o) return <div className="panel"><div className="panel-body"><div className="empty">Chargement…</div></div></div>;
  return (
    <>
      <div className="kpi-grid">
        <div className="kpi navy"><span>Écoles clientes</span><strong>{o.totalTenants}</strong></div>
        <div className="kpi green"><span>Actives</span><strong>{o.byStatus.ACTIF}</strong></div>
        <div className="kpi"><span>Abonnements actifs</span><strong>{o.activeSubscriptions}</strong></div>
        <div className="kpi gold"><span>MRR estimé</span><strong style={{ fontSize: '1.35rem' }}>{formatXof(o.mrr)}</strong></div>
      </div>
      <div className="panel" style={{ marginTop: 16 }}>
        <div className="panel-head">
          <h2>Répartition des écoles</h2>
          <button className="btn-ghost btn-sm" onClick={() => navigate('/plateforme/ecoles')}>Vue →</button>
        </div>
        <div className="panel-body">
          <div className="kpi-grid">
            {Object.entries(o.byStatus).map(([k, v]) => (
              <div key={k} className="kpi"><span>{(TSTATUS[k] || [])[1] || k}</span><strong>{v}</strong></div>
            ))}
          </div>
        </div>
      </div>
      <div className="panel" style={{ marginTop: 16 }}>
        <div className="panel-head">
          <h2>Plans disponibles</h2>
          <button className="btn btn-sm" onClick={() => setModal({})}>+ Nouveau plan</button>
        </div>
        <div className="panel-body">
          {error && <div className="form-error">{error}</div>}
          {o.plans.length === 0 ? <div className="empty">Aucun plan.</div> : (
            <div className="table-wrap"><table>
              <thead><tr><th>Plan</th><th>Code</th><th>Cycle</th><th className="num">Prix annuel</th><th className="num">Frais install.</th><th className="num">Max élèves</th><th></th></tr></thead>
              <tbody>{o.plans.map((p) => (
                <tr key={p.id}>
                  <td><b>{p.name}</b></td>
                  <td className="mono">{p.code}</td>
                  <td>{BILLING[p.billing] || p.billing}</td>
                  <td className="num">{formatXof(p.priceXof)}</td>
                  <td className="num">{formatXof(p.setupFeeXof ?? 0)}</td>
                  <td className="num">{p.maxStudents ?? '∞'}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn-ghost btn-sm" onClick={() => setModal(p)}>Modifier</button>
                    <button className="link-danger" onClick={() => del(p.id)}>Supprimer</button>
                  </td>
                </tr>
              ))}</tbody>
            </table></div>
          )}
        </div>
      </div>
      {modal && <PlanModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </>
  );
}

// ── Écoles clientes ─────────────────────────────────────────
export function PlatformTenants() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  const [viewModal, setViewModal] = useState(null);
  function load() { api.get(`/platform/tenants${search.trim() ? `?search=${encodeURIComponent(search.trim())}` : ''}`).then(setRows).catch((e) => setError(e.message)); }
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [search]);
  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Écoles clientes</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="search-input" style={{ width: 200 }} placeholder="Nom, code, ville…" value={search} onChange={(e) => setSearch(e.target.value)} />
          <button className="btn btn-sm" onClick={() => setModal({})}>+ Nouvelle école</button>
        </div>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {rows.length === 0 ? <div className="empty">Aucune école.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>École</th><th>Code</th><th>Ville</th><th>Statut</th><th className="num">Élèves</th><th className="num">Comptes</th><th>Plan</th><th></th></tr></thead>
            <tbody>{rows.map((t) => (
              <tr key={t.id}>
                <td><b>{t.name}</b>{t.subdomain && <><br /><small className="mono" style={{ color: 'var(--muted)' }}>{t.subdomain}</small></>}</td>
                <td className="mono">{t.code}</td>
                <td>{t.city || '—'}</td>
                <td><span className={`badge ${(TSTATUS[t.status] || [])[0] || 'navy'}`}>{(TSTATUS[t.status] || [])[1] || t.status}</span></td>
                <td className="num">{t.studentsCount}</td>
                <td className="num">{t.usersCount}</td>
                <td>{t.currentPlan || '—'}</td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button className="btn-ghost btn-sm" onClick={() => setViewModal(t)}>Vue</button>
                  <button className="btn-ghost btn-sm" onClick={() => setModal(t)}>Modifier</button>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
      {modal && <TenantModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
      {viewModal && <TenantViewModal tenant={viewModal} onClose={() => setViewModal(null)} onEdit={() => { setModal(viewModal); setViewModal(null); }} />}
    </div>
  );
}

function TenantViewModal({ tenant, onClose, onEdit }) {
  const st = TSTATUS[tenant.status] || ['navy', tenant.status];
  const row = (label, val) => (
    <div><span style={{ color: 'var(--muted)', fontSize: '0.78rem' }}>{label}</span><br /><b>{val || '—'}</b></div>
  );
  return (
    <Modal title="Fiche établissement" onClose={onClose}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: '1.15rem', fontWeight: 700 }}>{tenant.name}</div>
          {tenant.subdomain && <div className="mono" style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>{tenant.subdomain}</div>}
        </div>
        <span className={`badge ${st[0]}`}>{st[1]}</span>
      </div>

      <p style={{ fontWeight: 600, margin: '0 0 6px', fontSize: '0.78rem', textTransform: 'uppercase', color: 'var(--muted)', letterSpacing: '0.05em' }}>Identification</p>
      <div className="grid-3" style={{ gap: '8px 20px', fontSize: '0.88rem', marginBottom: 14 }}>
        {row('Code', <span className="mono">{tenant.code}</span>)}
        {row('Date de création', tenant.createdAt ? new Date(tenant.createdAt).toLocaleDateString('fr-FR') : null)}
        {row('Forme juridique', tenant.formeJuridique)}
        {row('Promoteur', tenant.promoteur)}
        {row('Directeur', tenant.directeur)}
        {row('Plan actuel', tenant.currentPlan)}
      </div>

      <p style={{ fontWeight: 600, margin: '0 0 6px', fontSize: '0.78rem', textTransform: 'uppercase', color: 'var(--muted)', letterSpacing: '0.05em' }}>Documents légaux</p>
      <div className="grid-3" style={{ gap: '8px 20px', fontSize: '0.88rem', marginBottom: 14 }}>
        {row('RCCM', tenant.rccm)}
        {row('Récépissé', tenant.recepisse)}
        {row('IFU', tenant.ifu)}
        <div style={{ gridColumn: 'span 3' }}><span style={{ color: 'var(--muted)', fontSize: '0.78rem' }}>Agréments & autorisations</span><br /><b>{tenant.agrements || '—'}</b></div>
      </div>

      <p style={{ fontWeight: 600, margin: '0 0 6px', fontSize: '0.78rem', textTransform: 'uppercase', color: 'var(--muted)', letterSpacing: '0.05em' }}>Contact & localisation</p>
      <div className="grid-3" style={{ gap: '8px 20px', fontSize: '0.88rem', marginBottom: 14 }}>
        {row('Pays', tenant.pays)}
        {row('Région', tenant.region)}
        {row('Ville / Commune', tenant.city)}
        {row('Téléphone', tenant.phone)}
        {row('E-mail', tenant.email)}
        {row('Élèves', tenant.studentsCount)}
        {row('Comptes', tenant.usersCount)}
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
        <button className="btn" style={{ width: 'auto', padding: '0 22px' }} onClick={onEdit}>Modifier</button>
        <button type="button" className="btn-ghost" onClick={onClose}>Fermer</button>
      </div>
    </Modal>
  );
}
function TenantModal({ initial, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({
    code: initial.code || '',
    name: initial.name || '',
    subdomain: initial.subdomain || '',
    status: initial.status || 'ESSAI',
    pays: initial.pays || '',
    region: initial.region || '',
    city: initial.city || '',
    phone: initial.phone || '',
    email: initial.email || '',
    createdAt: initial.createdAt ? new Date(initial.createdAt).toISOString().slice(0, 10) : '',
    promoteur: initial.promoteur || '',
    directeur: initial.directeur || '',
    formeJuridique: initial.formeJuridique || '',
    rccm: initial.rccm || '',
    recepisse: initial.recepisse || '',
    ifu: initial.ifu || '',
    agrements: initial.agrements || '',
  });
  const [createAdmin, setCreateAdmin] = useState(false);
  const [admin, setAdmin] = useState({ firstName: '', lastName: '', email: '', password: '' });
  const [error, setError] = useState('');

  const regions = f.pays ? Object.keys(GEO[f.pays] || {}) : [];
  const villes  = (f.pays && f.region) ? (GEO[f.pays]?.[f.region] || []) : [];
  const setA = (k) => (e) => setAdmin((prev) => ({ ...prev, [k]: e.target.value }));

  function set(k) {
    return (e) => {
      const val = e.target.value;
      if (k === 'pays')   return setF((p) => ({ ...p, pays: val, region: '', city: '' }));
      if (k === 'region') return setF((p) => ({ ...p, region: val, city: '' }));
      setF((p) => ({ ...p, [k]: val }));
    };
  }

  async function submit(e) {
    e.preventDefault(); setError('');
    try {
      if (isEdit) {
        await api.patch(`/platform/tenants/${initial.id}`, f);
      } else {
        const created = await api.post('/platform/tenants', f);
        if (createAdmin && admin.email && admin.password) {
          await api.post(`/platform/tenants/${created.id}/admin`, admin);
        }
      }
      onSaved();
    }
    catch (err) { setError(err.message); }
  }

  const sec = (label) => (
    <p style={{ fontWeight: 600, margin: '14px 0 8px', fontSize: '0.78rem', textTransform: 'uppercase', color: 'var(--muted)', letterSpacing: '0.05em' }}>{label}</p>
  );

  return (
    <Modal title={isEdit ? "Modifier l'école" : 'Nouvelle école cliente'} onClose={onClose}>
      {error && <div className="form-error">{error}</div>}
      <form onSubmit={submit}>
        {sec('Identification')}
        <div className="grid-3">
          <div className="field"><label>Code *</label><input value={f.code} onChange={set('code')} required disabled={isEdit} placeholder="ex. GSLP" /></div>
          <div className="field" style={{ gridColumn: 'span 2' }}><label>Nom de l'établissement *</label><input value={f.name} onChange={set('name')} required /></div>
          <div className="field"><label>Sous-domaine</label><input value={f.subdomain} onChange={set('subdomain')} placeholder="laprovidence" /></div>
          <div className="field"><label>Statut</label><select value={f.status} onChange={set('status')}>{Object.keys(TSTATUS).map((s) => <option key={s} value={s}>{TSTATUS[s][1]}</option>)}</select></div>
          <div className="field"><label>Date de création</label><input type="date" value={f.createdAt} onChange={set('createdAt')} /></div>
          <div className="field"><label>Promoteur</label><input value={f.promoteur} onChange={set('promoteur')} /></div>
          <div className="field"><label>Directeur</label><input value={f.directeur} onChange={set('directeur')} /></div>
          <div className="field"><label>Forme juridique</label>
            <select value={f.formeJuridique} onChange={set('formeJuridique')}>
              <option value="">— Sélectionner —</option>
              {FORMES_JURIDIQUES.map((fj) => <option key={fj} value={fj}>{fj}</option>)}
            </select>
          </div>
        </div>

        {sec('Documents légaux')}
        <div className="grid-3">
          <div className="field"><label>RCCM</label><input value={f.rccm} onChange={set('rccm')} /></div>
          <div className="field"><label>Récépissé</label><input value={f.recepisse} onChange={set('recepisse')} /></div>
          <div className="field"><label>IFU</label><input value={f.ifu} onChange={set('ifu')} /></div>
          <div className="field" style={{ gridColumn: 'span 3' }}><label>Références agréments & autorisations</label><textarea value={f.agrements} onChange={set('agrements')} rows={2} style={{ width: '100%', resize: 'vertical' }} /></div>
        </div>

        {sec('Contact & localisation')}
        <div className="grid-3">
          <div className="field"><label>Pays</label>
            <select value={f.pays} onChange={set('pays')}>
              <option value="">— Sélectionner —</option>
              {Object.keys(GEO).map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div className="field"><label>Région {f.pays === 'Bénin' ? '/ Département' : ''}</label>
            <select value={f.region} onChange={set('region')} disabled={!regions.length}>
              <option value="">— Sélectionner —</option>
              {regions.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div className="field"><label>Ville {f.pays === 'Bénin' ? '/ Commune' : ''}</label>
            <select value={f.city} onChange={set('city')} disabled={!villes.length}>
              <option value="">— Sélectionner —</option>
              {villes.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
          <div className="field"><label>Téléphone</label><input value={f.phone} onChange={set('phone')} /></div>
          <div className="field" style={{ gridColumn: 'span 2' }}><label>E-mail</label><input value={f.email} onChange={set('email')} /></div>
        </div>

        {!isEdit && (
          <div style={{ borderTop: '1px solid var(--border)', marginTop: 14, paddingTop: 14 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}>
              <input type="checkbox" checked={createAdmin} onChange={(e) => setCreateAdmin(e.target.checked)} />
              Créer un compte administrateur pour cette école
            </label>
            {createAdmin && (
              <div className="grid-3" style={{ marginTop: 12 }}>
                <div className="field"><label>Prénom</label><input value={admin.firstName} onChange={setA('firstName')} placeholder="Admin" /></div>
                <div className="field"><label>Nom</label><input value={admin.lastName} onChange={setA('lastName')} /></div>
                <div className="field"><label>E-mail *</label><input type="email" value={admin.email} onChange={setA('email')} required={createAdmin} /></div>
                <div className="field" style={{ gridColumn: 'span 3' }}><label>Mot de passe *</label><input type="password" value={admin.password} onChange={setA('password')} required={createAdmin} /></div>
              </div>
            )}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button className="btn" type="submit" style={{ width: 'auto', padding: '0 22px' }}>{isEdit ? 'Enregistrer' : 'Créer'}</button>
          <button type="button" className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </form>
    </Modal>
  );
}

// ── Plans d'abonnement ──────────────────────────────────────
export function PlatformPlans() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  function load() { api.get('/platform/plans').then(setRows).catch((e) => setError(e.message)); }
  useEffect(load, []);
  async function del(id) {
    if (!(await confirmDialog({ title: 'Supprimer', message: 'Supprimer ce plan ?', confirmLabel: 'Supprimer', danger: true }))) return;
    try { await api.del(`/platform/plans/${id}`); load(); } catch (e) { setError(e.message); }
  }
  return (
    <div className="panel">
      <div className="panel-head"><h2>Plans d'abonnement</h2><button className="btn btn-sm" onClick={() => setModal({})}>+ Nouveau plan</button></div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {rows.length === 0 ? <div className="empty">Aucun plan.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Plan</th><th>Code</th><th>Cycle</th><th className="num">Prix</th><th className="num">Frais install.</th><th className="num">Max élèves</th><th className="num">Abonnements</th><th></th></tr></thead>
            <tbody>{rows.map((p) => (
              <tr key={p.id}>
                <td><b>{p.name}</b></td><td className="mono">{p.code}</td><td>{BILLING[p.billing] || p.billing}</td>
                <td className="num">{formatXof(p.priceXof)}</td><td className="num">{formatXof(p.setupFeeXof ?? 0)}</td><td className="num">{p.maxStudents ?? '∞'}</td><td className="num">{p._count?.subscriptions ?? 0}</td>
                <td style={{ textAlign: 'right' }}><button className="btn-ghost btn-sm" onClick={() => setModal(p)}>Modifier</button><button className="link-danger" onClick={() => del(p.id)}>Supprimer</button></td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
      {modal && <PlanModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </div>
  );
}
function PlanModal({ initial, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ code: initial.code || '', name: initial.name || '', priceXof: initial.priceXof ?? '', setupFeeXof: initial.setupFeeXof ?? 50000, billing: initial.billing || 'ANNUEL', maxStudents: initial.maxStudents ?? '' });
  const [error, setError] = useState('');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  async function submit(e) {
    e.preventDefault(); setError('');
    try { if (isEdit) await api.patch(`/platform/plans/${initial.id}`, f); else await api.post('/platform/plans', f); onSaved(); }
    catch (err) { setError(err.message); }
  }
  return (
    <Modal title={isEdit ? 'Modifier le plan' : 'Nouveau plan'} onClose={onClose}>
      {error && <div className="form-error">{error}</div>}
      <form onSubmit={submit}>
        <div className="grid-3">
          <div className="field"><label>Code *</label><input value={f.code} onChange={set('code')} required disabled={isEdit} placeholder="STARTER" /></div>
          <div className="field" style={{ gridColumn: 'span 2' }}><label>Nom *</label><input value={f.name} onChange={set('name')} required /></div>
          <div className="field"><label>Prix (XOF)</label><input type="number" min="0" value={f.priceXof} onChange={set('priceXof')} /></div>
          <div className="field"><label>Frais d'installation (XOF)</label><input type="number" min="0" value={f.setupFeeXof} onChange={set('setupFeeXof')} /></div>
          <div className="field"><label>Cycle</label><select value={f.billing} onChange={set('billing')}>{Object.keys(BILLING).map((b) => <option key={b} value={b}>{BILLING[b]}</option>)}</select></div>
          <div className="field"><label>Max élèves</label><input type="number" min="0" value={f.maxStudents} onChange={set('maxStudents')} placeholder="illimité" /></div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button className="btn" type="submit" style={{ width: 'auto', padding: '0 22px' }}>{isEdit ? 'Enregistrer' : 'Créer'}</button>
          <button type="button" className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </form>
    </Modal>
  );
}

// ── Abonnements ─────────────────────────────────────────────
export function PlatformSubscriptions() {
  const [rows, setRows] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null); // null | { tenantId? }
  const [view, setView] = useState('active'); // 'active' | 'history'
  function load() { api.get('/platform/subscriptions').then(setRows).catch((e) => setError(e.message)); }
  useEffect(() => { load(); api.get('/platform/tenants').then(setTenants); api.get('/platform/plans').then(setPlans); }, []);

  async function close(id) {
    if (!(await confirmDialog({ title: 'Clôturer', message: 'Clôturer cet abonnement ?', confirmLabel: 'Clôturer', danger: true }))) return;
    try { await api.patch(`/platform/subscriptions/${id}/close`, {}); load(); } catch (e) { setError(e.message); }
  }

  const filtered = rows.filter((s) => view === 'active' ? s.status === 'active' : s.status !== 'active');

  return (
    <div className="panel">
      <div className="panel-head">
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <h2 style={{ margin: 0 }}>Abonnements</h2>
          <div style={{ display: 'flex', gap: 4 }}>
            <button
              className={view === 'active' ? 'btn btn-sm' : 'btn-ghost btn-sm'}
              onClick={() => setView('active')}
            >Actifs</button>
            <button
              className={view === 'history' ? 'btn btn-sm' : 'btn-ghost btn-sm'}
              onClick={() => setView('history')}
            >Historique</button>
          </div>
        </div>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {filtered.length === 0 ? <div className="empty">{view === 'active' ? 'Aucun abonnement actif.' : 'Aucun abonnement clôturé.'}</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr>
                <th>École</th><th>Plan</th><th className="num">Prix / an</th>
                <th className="num">Frais install.</th><th>Début</th><th>Fin</th><th>Statut</th>
                {view === 'active' && <th></th>}
              </tr>
            </thead>
            <tbody>{filtered.map((s) => (
              <tr key={s.id}>
                <td><b>{s.tenant?.name}</b><br /><small className="mono" style={{ color: 'var(--muted)' }}>{s.tenant?.code}</small></td>
                <td>{s.plan?.name}</td>
                <td className="num">{formatXof(s.plan?.priceXof || 0)}</td>
                <td className="num">{formatXof(s.plan?.setupFeeXof || 0)}</td>
                <td className="mono">{new Date(s.startDate).toLocaleDateString('fr-FR')}</td>
                <td className="mono">{s.endDate ? new Date(s.endDate).toLocaleDateString('fr-FR') : '—'}</td>
                <td>{s.status === 'active' ? <span className="badge green">Actif</span> : <span className="badge">Clôturé</span>}</td>
                {view === 'active' && (
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button className="btn-ghost btn-sm" onClick={() => setModal({ tenantId: s.tenantId })}>Changer de plan</button>
                    <button className="link-danger" onClick={() => close(s.id)}>Clôturer</button>
                  </td>
                )}
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
      {modal !== null && (
        <SubscribeModal
          tenants={tenants} plans={plans}
          defaultTenantId={modal.tenantId || ''}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </div>
  );
}

function SubscribeModal({ tenants, plans, defaultTenantId, onClose, onSaved }) {
  const [f, setF] = useState({
    tenantId: defaultTenantId || tenants[0]?.id || '',
    planId: plans[0]?.id || '',
    startDate: new Date().toISOString().slice(0, 10),
  });
  const [error, setError] = useState('');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const selectedPlan = plans.find((p) => p.id === f.planId);

  async function submit(e) {
    e.preventDefault(); setError('');
    try { await api.post('/platform/subscriptions', f); onSaved(); } catch (err) { setError(err.message); }
  }

  return (
    <Modal title="Abonner une école" onClose={onClose}>
      {error && <div className="form-error">{error}</div>}
      <form onSubmit={submit}>
        <div className="grid-3">
          <div className="field" style={{ gridColumn: 'span 2' }}>
            <label>École *</label>
            <select value={f.tenantId} onChange={set('tenantId')} required>
              {tenants.map((t) => <option key={t.id} value={t.id}>{t.name} ({t.code})</option>)}
            </select>
          </div>
          <div className="field">
            <label>Date de début</label>
            <input type="date" value={f.startDate} onChange={set('startDate')} />
          </div>
          <div className="field" style={{ gridColumn: 'span 3' }}>
            <label>Plan *</label>
            <select value={f.planId} onChange={set('planId')} required>
              {plans.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name} — {formatXof(p.priceXof)} / {BILLING[p.billing]}
                </option>
              ))}
            </select>
          </div>
        </div>
        {selectedPlan && (
          <div style={{ background: 'var(--surface)', borderRadius: 8, padding: '10px 14px', marginTop: 12, fontSize: '0.85rem', display: 'flex', gap: 24 }}>
            <span>Prix : <b>{formatXof(selectedPlan.priceXof)}</b> / {BILLING[selectedPlan.billing]}</span>
            <span>Frais d'installation : <b>{formatXof(selectedPlan.setupFeeXof ?? 0)}</b></span>
            <span>Max élèves : <b>{selectedPlan.maxStudents ?? '∞'}</b></span>
          </div>
        )}
        <p style={{ color: 'var(--muted)', fontSize: '0.82rem', marginTop: 10 }}>
          L'abonnement actif précédent est clôturé automatiquement.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
          <button className="btn" type="submit" style={{ width: 'auto', padding: '0 22px' }}>Abonner</button>
          <button type="button" className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </form>
    </Modal>
  );
}
